import { load, ReCaptchaInstance } from "recaptcha-v3";

export const recaptchaInit = (): Promise<ReCaptchaInstance | undefined> =>
  load("6LfNpf0UAAAAABDNFLhZ2a6eHBt6aRZGugDwsoLU", {
    autoHideBadge: true,
  }).catch((error) => {
    console.error("Recaptcha Error", error);
    return undefined;
  });
